/**
 * Categories
 */

import { Category } from '../../types/category.types';
import { SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET } from '../action-types/category.action-types';

export const saveCategoryTree = (data: Array<Category>) => ({ type: SEARCH_AUTOCOMPLETE_CATEGORY_TREE_SET, data });
